import React from "react";
import Box from "react-raster";
import styled from "styled-components";
import Container from "../Container";
import { H2, Copy, Eyebrow } from "../Typography";
import ButtonLink from "../ButtonLink";

const Wrapper = styled.div`
  background-color: ${({ theme, $backgroundColour }) =>
    theme.colours[$backgroundColour]};
  padding-bottom: ${({ isSticky }) => isSticky && "55vh"};
  padding-top: ${({ $hasTopMargin }) => ($hasTopMargin ? "60px" : "20px")};
  position: ${({ isSticky }) => isSticky && "sticky"};
  top: 0;

  // prevents text from overlapping prevoius component on vertically short viewports
  @media (max-height: 812px) {
    position: static;
    padding-bottom: 0;
  }
`;

const Column = styled(Box)`
  &:nth-child(odd) {
    padding-bottom: 20px;
  }

  @media (${({ theme }) => theme.mq.m}) {
    padding-bottom: 0;
    &:nth-child(odd) {
      padding-right: 5%;
    }
    &:nth-child(even) {
      padding-left: 5%;
    }
  }
`;

const LinkWrapper = styled.div`
  color: ${({ theme }) => theme.colours.grey};
  display: flex;
  align-items: center;
  margin-top: 30px;
`;

function TitleAndRightColumn({
  eyebrow,
  title,
  description,
  backgroundColour,
  isSticky,
  hideTitle,
  ctaUrl,
  ctaLabel,
  hasBottomMargin,
  hasTopMargin,
}) {
  const hasWhiteBackground =
    backgroundColour === "white" || backgroundColour === "alabasterWhite";
  return (
    <Wrapper
      $backgroundColour={backgroundColour}
      $hasBottomMargin={hasBottomMargin}
      $hasTopMargin={hasTopMargin}
      as="section"
      isSticky={isSticky}
    >
      <Container
        backgroundColour={backgroundColour}
        hasBottomMargin={hasBottomMargin}
      >
        <Column marginTop={1} cols={6} marginBottom={0.5}>
          {eyebrow && (
            <Eyebrow colour={!hasWhiteBackground && "white"}>{eyebrow}</Eyebrow>
          )}
          {!hideTitle && (
            <H2 $colour={!hasWhiteBackground && "white"}>{title}</H2>
          )}
        </Column>
        <Column marginTop={[0, 1]} cols={6} marginBottom={0.5}>
          {description && (
            <Copy
              medium
              style={{ marginBottom: ctaUrl && "60px" }}
              colour={!hasWhiteBackground && "white"}
              animated
            >
              {description}
            </Copy>
          )}
          {ctaUrl && (
            <LinkWrapper>
              <ButtonLink
                isWhite={
                  !!(
                    !backgroundColour ||
                    backgroundColour === "default" ||
                    backgroundColour === "white" ||
                    backgroundColour === "alabasterWhite"
                  )
                }
                label={ctaLabel}
                url={ctaUrl}
              />
            </LinkWrapper>
          )}
        </Column>
      </Container>
    </Wrapper>
  );
}
export default TitleAndRightColumn;
